import { Carousel } from "antd";
import styles from "./AlphaSlider.module.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AlphaSlider = ({ slides, dt_slides, dotS }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (window.innerWidth > 576) {
            setItems(dt_slides);
        } else {
            setItems(slides);
        }
    }, [dt_slides, slides]);

    const onChange = (currentSlide) => {
        setCurrentSlide(currentSlide);
    };

    return (
        <div className={styles.wrapper}>
            <Carousel
                dots={false}
                afterChange={onChange}
                // autoplay={true}
                draggable={true}
            >
                {items.map((slide, index) => {
                    return (
                        <Link to={slide.url} key={index}>
                            <div className={styles.item}>
                                <img src={slide.img} alt="" />
                            </div>
                        </Link>
                    );
                })}
            </Carousel>
            <div className={styles.dots} style={{ marginTop: dotS ? "30px" : null }}>
                <ul>
                    {items.map((slide, index) => {
                        return (
                            <li
                                key={index}
                                style={{
                                    backgroundColor: currentSlide === index ? "var(--color-primary)" : null,
                                    width: currentSlide === index ? "25px" : null,
                                    borderRadius: currentSlide === index ? "20px" : null,
                                }}
                            ></li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default AlphaSlider;
